import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";
import Countdown from "../react/Countdown";

export default class extends Controller {
  static targets = ["mount"];

  connect() {
    const el = this.mountTarget;
    const props = JSON.parse(el.getAttribute("data-props") || "{}");
    this.root = createRoot(el);
    this.root.render(<Countdown {...props} />);
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
    this.root = null;
  }
}
